import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  formatIndicationDisplay,
  formatOcCodeLabel,
} from '../../utils/ocRequest';

const display = value => {
  if (value == null || value === '') return '—';
  return String(value);
};

const formatDate = value => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return String(value);
  }
};

/**
 * Full contact + criteria block matching public create form fields.
 *
 * @param {Object} props
 * @param {Object} props.request - OC request detail payload (top-level contact + nested criteria)
 */
const OcRequestCriteriaSummary = ({ request }) => {
  const data = request || {};
  const criteria = data.criteria || {};

  return (
    <Row className="g-3">
      <Col md={6}>
        <h6 className="text-muted mb-2">Contact & project</h6>
        <div>
          <strong>Organization:</strong> {display(data.organization)}
        </div>
        <div>
          <strong>Contact person:</strong> {display(data.contact_person)}
        </div>
        <div>
          <strong>Contact email:</strong> {display(data.contact_email)}
        </div>
        <div>
          <strong>Contact phone:</strong> {display(data.contact_phone)}
        </div>
        <div>
          <strong>Project name:</strong> {display(data.project_name)}
        </div>
        <div>
          <strong>Purchase order ref:</strong> {display(data.purchase_order_ref)}
        </div>
        <div>
          <strong>Requested delivery date:</strong>{' '}
          {formatDate(data.requested_delivery_date)}
        </div>
      </Col>
      <Col md={6}>
        <h6 className="text-muted mb-2">Culture requirements</h6>
        <div>
          <strong>Indication:</strong> {formatIndicationDisplay(criteria.indication)}
          {criteria.indication_other ? ` (${criteria.indication_other})` : ''}
        </div>
        <div>
          <strong>Total vials:</strong> {display(criteria.cultures_requested)}
        </div>
        <div>
          <strong>Vials by indication / quantity notes:</strong>{' '}
          {display(criteria.quantity_per_culture)}
        </div>
        <div>
          <strong>Specific OC numbers:</strong> {display(criteria.specific_oc_numbers)}
        </div>
        <div>
          <strong>KRAS status:</strong> {formatOcCodeLabel(criteria.kras_status)}
        </div>
        <div>
          <strong>Other molecular:</strong> {display(criteria.other_molecular)}
        </div>
        <div>
          <strong>Treatment history:</strong> {display(criteria.treatment_history)}
        </div>
        <div>
          <strong>Passage requirements:</strong>{' '}
          {display(criteria.passage_requirements)}
        </div>
        <div>
          <strong>Preferred format:</strong> {formatOcCodeLabel(criteria.preferred_format)}
        </div>
        <div>
          <strong>Required medium:</strong> {display(criteria.required_medium)}
        </div>
        <div>
          <strong>Research purpose:</strong> {display(criteria.research_purpose)}
        </div>
        <div>
          <strong>Special requests:</strong> {display(criteria.special_requests)}
        </div>
        <div>
          <strong>Mandatory requirements:</strong>{' '}
          {display(criteria.mandatory_requirements)}
        </div>
        <div>
          <strong>Preferred requirements:</strong>{' '}
          {display(criteria.preferred_requirements)}
        </div>
      </Col>
    </Row>
  );
};

export default OcRequestCriteriaSummary;
